import React from "react";
import PropTypes from "prop-types";

import { OrderObject } from "./Queries/OrderQuery";

const InactiveSalesRepWarning = ({ order }) => {
  if (!order.uiState.showInactiveSalesRepWarning) {
    return null;
  }

  const gpCode = order.salesRep && order.salesRep.gpCode;
  const message = gpCode
    ? `Warning: The sales rep (${gpCode}) on this order is inactive and needs to be updated`
    : "Warning: The sales rep on this order is inactive and needs to be updated";

  return (
    <h3 className="red">
      <strong>{message}</strong>
    </h3>
  );
};

InactiveSalesRepWarning.propTypes = {
  order: OrderObject
};

export default InactiveSalesRepWarning;
